module.exports = __webpack_public_path__ + "static/pricing-mobile-2f647d47aa4f76cc97da2a898873b3cf.png";